import TOURNAMENT from "../actions/tournament/types";
import GAME from "../actions/lobby/types";
import UserSocket from "../../sockets/user-socket";

const initialState = {
    list: {},
    topWinners: [],
    sideBarTournamentId: null,
};
const reducer = (state = initialState, action) => {
        const socket = UserSocket.debouncedEmit.bind(UserSocket);
        switch (action?.type) {
            case TOURNAMENT.INITIAL_LOAD:
                return {
                    ...state,
                    list: action.payload.tournamentList,
                    topWinners: action.payload.topWinners
                };

            case TOURNAMENT.SET_TOURNAMENTS:
                return {
                    ...state,
                    list: action.payload.tournamentList
                };

            case TOURNAMENT.JOIN_TOURNAMENT:
                socket(GAME.EVENT, {action: action.type, payload: action.payload, ctx: 'Tournaments'})
                return state;

            case TOURNAMENT.QUIT_TOURNAMENT:
                socket(GAME.EVENT, {action: action.type, payload: action.payload, ctx: 'Tournaments'})
                return state;

            case TOURNAMENT.UPDATE_PLAYERS:
                return {
                    ...state,
                    list: {
                        ...state.list,
                        [action.payload.tournamentId]: {
                            ...state.list?.[action.payload.tournamentId],
                            players:action.payload.players
                        }
                    }
                }

            case TOURNAMENT.SET_NEW_TOURNAMENT:
                return {
                    ...state,
                    list: {
                        ...state.list,
                        ...action.payload.tournament
                    }
                }

            case TOURNAMENT.OPEN_TOURNAMENT_REGISTRATION:
                return {
                    ...state,
                    list: {
                        ...state.list,
                        [action.payload.tournamentId]: {
                            ...state.list[action.payload.tournamentId],
                            info: {
                                ...state.list[action.payload.tournamentId]?.info,
                                registrationEnabled: true
                            }

                        }
                    }
                }

            case TOURNAMENT.UPDATE_TOURNAMENT:
                return {
                    ...state,
                    list: {
                        ...state.list,
                        [action.payload.tournamentId]: {
                            ...state.list[action.payload.tournamentId],
                            ...action.payload.data
                        }
                    }
                }

            case TOURNAMENT.SET_SIDEBAR_TOURNAMENT_ID:
                return {
                    ...state,
                    sideBarTournamentId: action.payload.tournamentId
                }

            case TOURNAMENT.UPDATE_TOURNAMENT_BETTING_TIMER:
                return {
                    ...state,
                    list: {
                        ...state.list,
                        [action.payload.tournamentId]: {
                            ...state.list[action.payload.tournamentId],
                            info: {
                                ...state.list[action.payload.tournamentId]?.info,
                                bettingTimer: action.payload.bettingTimer
                            }

                        }
                    }
                }
            case TOURNAMENT.DELETE_TOURNAMENT:
                const {[action.payload.tournamentId]: _, ...updatedList} = state.list;
                const sideBarId = action.payload.tournamentId === state.sideBarTournamentId ? null : state.sideBarTournamentId
                return {
                    ...state,
                    list: updatedList,
                    sideBarTournamentId: sideBarId
                };

            case TOURNAMENT.UPDATE_TOP_WINNERS:
                return {
                    ...state,
                    topWinners: action.payload.topWinners
                }

            default:
                return state;
        }
    }
;
export default reducer;
